var ready = require('./ready.js');

// When using this, please note that elements to be handled should
// be present after page load. 
ready(function() {
    var elements = document.querySelectorAll('.show-below-fold');
    var userScrolled = false;
    window.onscroll = function() { userScrolled = true };

    var updateClasses = function() {
        var belowFold = window.scrollY > 500;
        var i;
        if (belowFold) {
            for (i = 0; i < elements.length; i++) {
                elements[i].classList.add('shown');
            }
        } else {
            for (i = 0; i < elements.length; i++) {
                elements[i].classList.remove('shown');
            }
        }
    };

    setInterval(function() {
        if (userScrolled) {
            updateClasses();
            userScrolled = false;
        }
    }, 200);

    updateClasses();
});
